import {
    REQUEST_FETCHED,
    SET_REQUEST,
    APPROVE_REQUEST,
    APPROVE_LOADING,
    REJECT_REQUEST,
    REJECTED,
    NEW_REQUESTS_COUNT,
    ASSIGNEE_EMPLOYEE,
  
} from "../types";

const initialState = {
    requestData: [] as any,
    singleRequst: {},
    approvedRequest: {},
    rejectedRequest: {},
    approveLoading: false,
    rejected: false,
    reportData: [] as any,
    reportDataCount: 0,
    assigneeEmployee: [] as any,
    exportedRequestByStatus:[] as any 
};
const requests = (state = initialState, action : any) => {
    switch (action.type) {
        case REQUEST_FETCHED:
            return {
                ...state,
                requestData: action.requestData,
                loading: false
            };

        case SET_REQUEST:
            return {
                ...state,
                singleRequst: action.singleRequst,
                // loading: false,
            };
        case APPROVE_REQUEST:
            return {
                ...state,
                approvedRequest: action.approvedRequest,
                approveLoading: action.approveLoading
            };
        case APPROVE_LOADING:
            return {
                ...state,
                approveLoading: action.approveLoading
            };
        case REJECT_REQUEST:
            return {
                ...state,
                rejectedRequest: action.rejectedRequest
            };
        case REJECTED:
            return {
                ...state,
                rejected: action.rejected
            };
        case ASSIGNEE_EMPLOYEE:
            return {
                ...state,
                assigneeEmployee: action.assigneeEmployee
            };
        case NEW_REQUESTS_COUNT:
            return {
                ...state,
                reportDataCount: action.requestsByStatusCount,
                dataCount: action.requestsByStatusCount
            };
       
        

        default:
            return state;
    }
};

export default requests;



